import { useEffect, useMemo, useState } from 'react';

const MOBILE_PHONE_MAX_WIDTH = 767;

const getNavigatorUserAgent = () => {
  if (typeof navigator === 'undefined') return '';
  return navigator.userAgent || navigator.vendor || window.opera || '';
};

const detectMobilePhone = () => {
  if (typeof window === 'undefined') return false;

  const width = window.innerWidth || document.documentElement.clientWidth || 0;
  const coarsePointer = window.matchMedia?.('(pointer: coarse)').matches ?? false;
  const hoverless = window.matchMedia?.('(hover: none)').matches ?? false;
  const narrowViewport = window.matchMedia?.(`(max-width: ${MOBILE_PHONE_MAX_WIDTH}px)`).matches ?? width <= MOBILE_PHONE_MAX_WIDTH;
  const userAgent = getNavigatorUserAgent();
  const phoneUserAgent = /Android.*Mobile|iPhone|iPod|IEMobile|Opera Mini|BlackBerry|webOS/i.test(userAgent);
  const tabletUserAgent = /iPad|Android(?!.*Mobile)|Tablet|PlayBook|Silk/i.test(userAgent);

  return !tabletUserAgent && narrowViewport && (phoneUserAgent || (coarsePointer && hoverless));
};

export const useDeviceType = () => {
  const [isMobilePhone, setIsMobilePhone] = useState(() => detectMobilePhone());

  useEffect(() => {
    const updateDeviceType = () => setIsMobilePhone(detectMobilePhone());
    const viewportQuery = window.matchMedia?.(`(max-width: ${MOBILE_PHONE_MAX_WIDTH}px)`);
    const pointerQuery = window.matchMedia?.('(pointer: coarse)');

    window.addEventListener('resize', updateDeviceType);
    window.addEventListener('orientationchange', updateDeviceType);
    viewportQuery?.addEventListener?.('change', updateDeviceType);
    pointerQuery?.addEventListener?.('change', updateDeviceType);

    updateDeviceType();

    return () => {
      window.removeEventListener('resize', updateDeviceType);
      window.removeEventListener('orientationchange', updateDeviceType);
      viewportQuery?.removeEventListener?.('change', updateDeviceType);
      pointerQuery?.removeEventListener?.('change', updateDeviceType);
    };
  }, []);

  return useMemo(() => ({
    isMobilePhone,
    isDesktop: !isMobilePhone,
  }), [isMobilePhone]);
};

export default useDeviceType;
